// extracted by mini-css-extract-plugin
module.exports = {"visibleOnMobileLayout":"ModalInMobile.example_visibleOnMobileLayout__33dG8"};